import pathOr from "@ramda/pathor";
import { FormikHelpers } from "formik";
import { TFunction } from "i18next";
import { Map } from "immutable";
import { OpenRightPanel } from "types/common/rightPanel";
import { PackOptionsFormValues } from "types/StorageForms/PackOptions";
import {
  toastResponseError,
  toastResponseSuccess,
} from "utils/responseMessageHelper";

export const expectedPackOptionsFormik = (
  t: TFunction,
  openRightPanel: OpenRightPanel,
  panelData: any,
  updateExpectedItem: (
    id: any,
    data: { expected_shipment: any },
  ) => Promise<any>,
) => {
  const id = panelData.get("id");
  const currentAddons = panelData.get("expected_item_addons");
  const addonIds = currentAddons
    ? currentAddons.toJS
      ? currentAddons.toJS()
      : currentAddons
    : [];

  return {
    enableReinitialize: true,
    initialValues: {
      activeItem: { value: id },
      [id]: addonIds,
    },
    onSubmit: (
      values: PackOptionsFormValues,
      { setSubmitting }: FormikHelpers<PackOptionsFormValues>,
    ) => {
      const payload = {
        expected_shipment: {
          expected_item_addons: values[id],
        },
      };

      return updateExpectedItem(id, payload)
        .then((response: any) => {
          const value = pathOr(Map(), ["value"], response);
          const data = value.get("data");
          toastResponseSuccess(
            t("parcels.packOptionsSaved", {
              number:
                panelData.get("tracking_number") ||
                panelData.get("order_number"),
            }),
          );
          if (data) {
            openRightPanel(
              "EXPECTED_ITEM",
              data.merge(
                Map({
                  isEditForm: true,
                  selectedExpectedItem: data,
                }),
              ),
            );
          }
        })
        .catch((error: Error) => toastResponseError(error))
        .finally(() => setSubmitting(false));
    },
  };
};
